// Contenedor único para las 3 alertas que un inspector MSP/ACESS revisaría
// (2026-09-10, pedido explícito del usuario) — agrupa lo que antes eran 3
// widgets sueltos del dashboard (FormulariosPendientes, AlertasCompletitudPropias,
// AlertaClasificacionArchivo) bajo un solo título, para que el médico las vea
// como una sola lista de pendientes de auditoría en vez de 3 cosas
// desconectadas. Cada widget sigue siendo su propia tarjeta adentro (no se
// tocó su lógica ni su estado), solo cambia el envoltorio visual.
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { AlertaClasificacionArchivo } from './AlertaClasificacionArchivo';
import { AlertasCompletitudPropias } from './AlertasCompletitudPropias';
import { FormulariosPendientes } from './FormulariosPendientes';

export function PanelAlertasAuditoria(): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="rounded-lg border border-border bg-card p-3">
      <p className="text-sm font-semibold text-hce-ink">{t('dashboard.panelAlertasAuditoria.titulo')}</p>

      <div className="mt-3 space-y-3">
        <FormulariosPendientes />
        <AlertasCompletitudPropias />
        <AlertaClasificacionArchivo />
      </div>
    </div>
  );
}
